export default __webpack_public_path__ + "static/media/umer.956499f4.jpeg";